import { HttpInterceptorFn } from '@angular/common/http';

// let isRefreshing = false;

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  // const authStore = inject(AuthStore);
  // const injector = inject(Injector);

  // if (req.url.includes('/login')) {
  return next(req);
  // }
  // const request = req.clone({
  //   setHeaders: {
  //     Authorization: `Bearer ${authStore.token()}`,
  //   },
  // });

  // if (req.url.includes('refresh-token')) {
  //   return next(request);
  // }

  // const handleTokenExpired = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  //   if (!isRefreshing) {
  //     isRefreshing = true;
  //     return authStore.sendRefreshToken().pipe(
  //       switchMap(() => {
  //         isRefreshing = false;
  //         const request = req.clone({
  //           setHeaders: {
  //             Authorization: `Bearer ${authStore.token()}`,
  //           },
  //         });

  //         return next(request);
  //       }),
  //       catchError((err) => {
  //         isRefreshing = false;
  //         return throwError(() => err);
  //       })
  //     );
  //   } else {
  //     return toObservable(authStore.token, { injector }).pipe(
  //       filter((token) => !!token),
  //       take(1),
  //       switchMap(() => next(request))
  //     );
  //   }
  // };

  // return next(request).pipe(
  //   catchError((err: any) => {
  //     if (err.status === 401 && authStore.refreshToken()) {
  //       return handleTokenExpired(request, next);
  //     }
  //     return throwError(() => err);
  //   })
  // );
};
